import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface AIProcessingLogState {
  data: any[] | null;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allAIProcessingLogs: any[];
}

const initialState: AIProcessingLogState = {
  data: null,
  currentPage: null,
  totalRecords: null,
  totalPages: null,
  allAIProcessingLogs: [],
};

export const aiProcessingLogSlice = createSlice({
  name: "aiProcessingLog",
  initialState,
  reducers: {
    setAIProcessingLogs: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setAIProcessingLogsBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllAIProcessingLogs: (state, action) => {
      state.allAIProcessingLogs = action.payload.data;
    },
    resetAIProcessingLog: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setAIProcessingLogs,
  setAIProcessingLogsBySearch,
  setAllAIProcessingLogs,
  resetAIProcessingLog,
} = aiProcessingLogSlice.actions;

export const getAIProcessingLogData = (state: RootState) => state.aiProcessingLog.data;
export const getAIProcessingLogDataBySearch = (state: RootState) => state.aiProcessingLog.data;
export const getAllAIProcessingLogList = (state: RootState) => state.aiProcessingLog.allAIProcessingLogs;
export const getAIProcessingLogTotalRecords = (state: RootState) => state.aiProcessingLog.totalRecords;

export default aiProcessingLogSlice.reducer;
